import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'e5core-ui-datepicker',
  templateUrl: './e5core-ui-datepicker.component.html',
  styleUrls: ['./e5core-ui-datepicker.component.css'],
  providers: [
      { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => E5coreUiDatepickerComponent), multi: true },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class E5coreUiDatepickerComponent implements OnInit {
  @Input() public displayedDate: Date;
  @Input() public isDisabled: boolean;
  @Input() public placeHolder: string;
  @Input() public isRequired = false;
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(public _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  public updateDate(event) {
    console.log(event);
    this.displayedDate = event.target.value;
    this.dateChange.emit(this.displayedDate);
  }

  onKey(event: any) {
    const inputDate = event.target.value;

    if (inputDate.length === 8 && inputDate.indexOf('/') === -1) {
      const year = inputDate.substring(4);
      const month = Number(inputDate.substring(2, 4)) - 1;
      const day = inputDate.substring(0, 2);
     this.displayedDate = new Date(year, month, day);
      this.dateChange.emit(this.displayedDate);

    } else if (inputDate.length === 10 && inputDate.indexOf('/') >= 0) {
      const dateSplit = inputDate.split('/');
      if (dateSplit.length >= 3) {
        const day = dateSplit[0];
        const month = Number(dateSplit[1]) - 1;
        const year = dateSplit[2];
        this.displayedDate = new Date(year, month, day);        
        this.dateChange.emit(this.displayedDate);
      }
    }
  }

}
